import { h } from 'preact'
import classNames from 'clsx'

import styles from './index.module.scss'

const InlineTitle = ({ children, className, ...rest }) => (
  <h1 className={classNames(className, styles['a-inline-title'])} {...rest}>
    {children}
  </h1>
)

export default InlineTitle
